"use strict";
/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeArrayItemKeyGetter = void 0;
function normalizeArrayItemKeyGetter(x) {
    if (typeof x === 'function')
        return x;
    if (typeof x === 'string')
        return (item => (item ? item[x] : undefined));
    return undefined;
}
exports.normalizeArrayItemKeyGetter = normalizeArrayItemKeyGetter;
/**
 * 假设两个数组是 object[] 而且每一项都有 key，那么从数组1 -> 数组2，是可以复用一些元素的。
 * 这个方法可以找出，在新数组里，哪些是可以复用的。
 *
 * 这里包含了一些来自 snabbdom 的双指针算法，有大改
 *
 * @param arrayKey 数组项的 Key 怎么取？提示：key 如果重复了，虽然能正常工作，但是 **不保证** 复用的顺序！
 * @param greedyMatchUnkeyed 如果最后剩余了一堆元素，而且他们没有key，是否给他们按照index顺序强制复用？默认 false
 * @return 长度和 newCh 相同的数组，为在旧数组中对应复用的索引。如果为 -1 表示无复用的
 */
function computeArrayReuseMap(oldCh, newCh, arrayKey, greedyMatchUnkeyed) {
    const indexMap = Array.from({ length: newCh.length }, () => -1);
    const getKey = normalizeArrayItemKeyGetter(arrayKey);
    if (!getKey) {
        if (greedyMatchUnkeyed) {
            for (let i = 0; i < oldCh.length && i < newCh.length; i++) {
                indexMap[i] = i;
            }
        }
        return indexMap;
    }
    const keysOfOldItems = greedyMatchUnkeyed ? oldCh.map(() => null) : null;
    const createKeyToOldIdx = (children, beginIdx, endIdx) => {
        const map = {};
        for (let i = beginIdx; i <= endIdx; ++i) {
            const key = getKey(children[i], i, children);
            if (key == null)
                continue;
            if (!map[key])
                map[key] = [i];
            else
                map[key].push(i);
            if (keysOfOldItems && children === oldCh)
                keysOfOldItems[i] = key;
        }
        return map;
    };
    const sameVnode = (oldIdx, item1, newIdx, item2) => {
        const key1 = getKey(item1, oldIdx, oldCh);
        const key2 = getKey(item2, newIdx, newCh);
        if (key1 == null || key2 == null)
            return false;
        return key1 === key2;
    };
    let oldStartIdx = 0;
    let newStartIdx = 0;
    let oldEndIdx = oldCh.length - 1;
    let oldStartVnode = oldCh[0];
    let oldEndVnode = oldCh[oldEndIdx];
    let newEndIdx = newCh.length - 1;
    let newStartVnode = newCh[0];
    let newEndVnode = newCh[newEndIdx];
    let keyToOldIdxs;
    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        if (oldStartVnode == null) {
            /* istanbul ignore next */
            oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
        }
        else if (oldEndVnode == null) {
            /* istanbul ignore next */
            oldEndVnode = oldCh[--oldEndIdx];
        }
        else if (newStartVnode == null) {
            /* istanbul ignore next */
            newStartVnode = newCh[++newStartIdx];
        }
        else if (newEndVnode == null) {
            /* istanbul ignore next */
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldStartIdx, oldStartVnode, newStartIdx, newStartVnode)) {
            indexMap[newStartIdx] = oldStartIdx;
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        }
        else if (sameVnode(oldEndIdx, oldEndVnode, newEndIdx, newEndVnode)) {
            indexMap[newEndIdx] = oldEndIdx;
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldStartIdx, oldStartVnode, newEndIdx, newEndVnode)) {
            // 左边的飞到右边
            indexMap[newEndIdx] = oldStartIdx;
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldEndIdx, oldEndVnode, newStartIdx, newStartVnode)) {
            // 右边的飞到左边
            indexMap[newStartIdx] = oldEndIdx;
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        }
        else {
            // 低性能的处理
            if (keyToOldIdxs === undefined)
                keyToOldIdxs = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            const newKey = getKey(newStartVnode, newStartIdx, newCh);
            const tmpArr = newKey == null ? undefined : keyToOldIdxs[newKey];
            const idxInOld = tmpArr && tmpArr.shift();
            if (tmpArr && tmpArr.length === 0)
                keyToOldIdxs[newKey] = null;
            // 老元素复用
            if (typeof idxInOld === 'number')
                indexMap[newStartIdx] = idxInOld;
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (greedyMatchUnkeyed) {
        const unusedOldIdexes = Array.from(oldCh, (_, i) => i).filter((i) => {
            var _a;
            if (indexMap.includes(i))
                return false; // 这个元素已经复用过
            if (((_a = keysOfOldItems[i]) !== null && _a !== void 0 ? _a : getKey(oldCh[i], i, oldCh[i])) != null)
                return false; // 只考虑 unkeyed 元素
            return true;
        });
        for (let i = 0; i < newCh.length && unusedOldIdexes.length > 0; i++) {
            if (indexMap[i] === -1)
                indexMap[i] = unusedOldIdexes.shift();
        }
    }
    return indexMap;
}
exports.default = computeArrayReuseMap;
